export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (b4aa6615)";
export var THEME = "polaris";
export var ALWAYS_VISUAL_REFRESH = false;